module.exports = __webpack_public_path__ + "img/sicepat.46da65e3.png";